import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { FormTextArea } from "source/app/presentation/Shared/Form/TextArea/FormTextArea";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { ReadState } from "source/app/services/UI/State/ReadState";
import { SetState } from "source/app/services/UI/State/SetState";
import UI from "source/app/services/UI/UI";
import { IPrayerState } from "../Prayer";

export function PrayerBody() {
    const state = ReadState<IPrayerState>(ESharedFunction.Prayer_state);

    if (!state) {
        return null;
    }

    const setState = (newState: Partial<IPrayerState>) =>
        SetState<IPrayerState>(ESharedFunction.Prayer_state, newState);

    return (
        <div>
            <div>
                <span style={{ marginRight: `5px` }}>O lord</span>
                <FormTextArea
                    id="clickTarget_prayerBody"
                    width="46vw"
                    onChange={(value) => setState({ headerProblem: value })}
                    value={state.headerProblem}
                    classes={StyleClass(`prayerBodyInput`, {
                        position: "relative",
                        top: "13px",
                    })}
                    onEnter={() => {
                        setState({
                            bodyTexts: [
                                ...state.bodyTexts,
                                `O lord ${state.headerProblem}`,
                            ],
                            headerProblem: ``,
                        });
                    }}
                />
                <IconWithText
                    iconSuffix={EGlyphicon["ban-circle"]}
                    whenClicked={() => {
                        setState({ headerProblem: "", bodyTexts: [] });
                        UI.FocusOnElement("clickTarget_prayerBody");
                    }}
                    displayAsBlock
                    withClass={StyleClass(`prayerBodyClearLink`, {
                        opacity: 0.6,
                        margin: `25px 0px 5px 0px`,
                    })}
                >
                    Clear
                </IconWithText>
            </div>
        </div>
    );
}
